// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useToast} from '@supermove/hooks';
import {ProjectModel} from '@supermove/models';

// App
import DeleteModal from '@shared/design/components/Modal/SmallModal/DeleteModal';
import Toast from '@shared/design/components/Toast';
import DeleteProjectForm from '@shared/modules/Project/forms/DeleteProjectForm';
import useDeleteProjectMutation from '@shared/modules/Project/hooks/useDeleteProjectMutation';

const DeleteProjectModal = ({
  project,
  isOpen,
  handleClose,
  refetch,
}: {
  project: ProjectModel;
  isOpen: boolean;
  handleClose: () => void;
  refetch: () => void;
}) => {
  const projectDeletedToast = useToast({ToastComponent: Toast, message: 'Project deleted.'});
  const deleteProjectForm = DeleteProjectForm.edit(project);
  const {handleSubmit, submitting} = useDeleteProjectMutation({
    deleteProjectForm,
    onSuccess: () => {
      projectDeletedToast.handleToast();
      handleClose();
      refetch();
    },
    onError: (errors: any) => {
      console.log({errors});
    },
  });

  return (
    <DeleteModal
      isOpen={isOpen}
      handleClose={handleClose}
      title={`Delete project?`}
      subtitle={'This action cannot be undone.'}
      isSubmitting={submitting}
      isMobileSheet
      handleDelete={handleSubmit}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
DeleteProjectModal.fragment = gql`
  ${DeleteProjectForm.edit.fragment}

  fragment DeleteProjectModal on Project {
    id
    ...DeleteProjectForm_edit
  }
`;

export default DeleteProjectModal;
